import { useLocation, useNavigate } from 'react-router-dom';
import { NAV_ITEMS, findActiveNavKey } from './navItems';
import { Tooltip } from '@/components/ui/tooltip';
import { BrandLogo } from '@/components/common/BrandLogo';
import { cn } from '@/lib/utils';

interface Props {
  collapsed?: boolean;
  onNavigate?: () => void;
}

export function Sidebar({ collapsed = false, onNavigate }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const activeKey = findActiveNavKey(location.pathname);

  return (
    <div className="flex flex-col h-full bg-card select-none">
      <div className="brand-mark">
        <BrandLogo
          variant={collapsed ? 'icon' : 'adaptive'}
          className={collapsed ? 'brand-mark__icon' : 'brand-mark__wordmark'}
        />
      </div>

      <div className="flex-1 px-3 py-2 space-y-1 overflow-y-auto">
        {NAV_ITEMS.map((item) => {
          const isActive = activeKey === item.key;
          const button = (
            <button
              key={item.key}
              type="button"
              onClick={() => {
                navigate(item.path);
                onNavigate?.();
              }}
              className={cn(
                'group w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer text-left',
                collapsed ? 'justify-center px-0' : '',
                isActive
                  ? 'bg-primary/10 text-primary font-semibold'
                  : 'text-foreground hover:bg-muted hover:text-primary'
              )}
            >
              <span
                className={cn(
                  'shrink-0 text-base',
                  isActive
                    ? 'text-primary'
                    : 'text-foreground group-hover:text-primary'
                )}
              >
                {item.icon}
              </span>
              {!collapsed && <span>{item.label}</span>}
            </button>
          );

          if (collapsed) {
            return (
              <Tooltip key={item.key} title={item.label} side="right">
                {button}
              </Tooltip>
            );
          }

          return button;
        })}
      </div>
    </div>
  );
}
